module.exports = __webpack_public_path__ + "static/media/redenvelopeparrot.43933837.gif";